import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/examine/report/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/examine/report/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/v4ward/examine/report/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/examine/report/submit', params,options)

export const update = (params, options) =>
request.post('/api/v4ward/examine/report/submit', params,options)
// 考核明细
// /v4ward/examine/report/detail

export const getReportDetail = (params, options) =>
request.get('/api/v4ward/examine/report/detail', Object.assign({}, options, { params }));
//项目字典接口
export const getProjectDictionary = (params, options) =>
  request.get('/api/v4ward/projectDict/dictionary', Object.assign({}, options, { params }));

// 不合格项 negativeList
export const negativeList = (params, options) =>
  request.get('/api/v4ward/examine/report/negativeList', Object.assign({}, options, { params }));
